var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_66",
    x: 80,
    y: 264,
    width: 38,
    height: 248,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Earthing"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Earthing",
    clipPath: "url(#clip-Earthing)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cable",
    transform: "translate(57 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M239.3,100.174V591.415c0,11.463,14.473,20.756,32.324,20.756s32.324-9.293,32.324-20.756V100.175S332.644,113.727,239.3,100.174Z",
    transform: "translate(0 -100.176)",
    fill: "#88939e"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 29,
    height: 272,
    rx: 14.5,
    transform: "translate(84 240)",
    fill: "#841717",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66-2",
    "data-name": "Rectangle 66",
    width: 38,
    height: 248,
    transform: "translate(80 264)",
    fill: "#841717"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66-3",
    "data-name": "Rectangle 66",
    width: 38,
    height: 248,
    transform: "translate(80 264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66-4",
    "data-name": "Rectangle 66",
    transform: "translate(80 264)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 248,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 247,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    transform: "translate(66 269)",
    fill: "#f1da69",
    stroke: "#f1da69",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rope-bridge-svgrepo-com",
    d: "M59.829,391c-12.821,0-86,31.05-100.146,36.45h0c15.195-6,89.788-18.45,100.146-18.45,12.749,0,25.761,7,39.919,15,14.185,8,29.462,17,47.376,17s33.19-9,47.376-17,27.189-15,39.919-15,25.734,7,39.919,15,29.462,17,47.376,17,33.19-9,47.376-17,27.189-15,39.919-15c10.366,0,60.689-5.5,75.874.5l-6.471-17.78c-14.185-5.4-56.582-.723-69.4-.723-17.914,0-33.19,9-47.376,17s-27.189,15-39.919,15-25.734-7-39.919-15-29.462-17-47.376-17-33.19,9-47.376,17-27.189,15-39.919,15-25.734-7-39.919-15C93.11,400,77.751,391,59.829,391Zm0,42c-12.821,0-80.128-13.089-94.268-7.689l-13.828,5.033C-40.489,444.121,49.472,451,59.82,451c12.73,0,25.752,7,39.928,15s29.462,17,47.376,17,33.19-9,47.376-17,27.189-15,39.919-15,25.734,7,39.919,15,29.462,17,47.376,17,33.19-9,47.376-17,27.189-15,39.919-15c10.366,0,65.3-34.824,80.487-28.824l-5.863-16.109C469.446,400.667,409.008,433,409.008,433s-33.19,9-47.376,17-27.189,15-39.919,15-25.734-7-39.919-15-29.462-17-47.376-17-33.19,9-47.376,17-27.189,15-39.919,15-25.734-7-39.919-15S77.733,433,59.82,433Z",
    transform: "translate(-267.228 317.036) rotate(-70)",
    fill: "#139b3b",
    stroke: "#a3ae11",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(117 272)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthing);
export default __webpack_public_path__ + "static/media/Earthing.139b6055194fd82dfbbe06fb3c9306ce.svg";
export { ForwardRef as ReactComponent };